import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/index.scss";

// Disable browser back button - must be registered before React Router mounts
window.__isBackNavigation = false;
window.addEventListener("popstate", () => {
  window.__isBackNavigation = true;
  window.history.go(1);
  setTimeout(() => {
    window.__isBackNavigation = false;
  }, 100);
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
if (process.env.NODE_ENV === "development") {
  root.render(
    <div>
      <App />
    </div>
  );
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
